<div class="filter-group" data-group-visibility-id="showJewelleryHighlights">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showJewelleryHighlights" (click)="filter.groupVisibility.showJewelleryHighlights = !filter.groupVisibility.showJewelleryHighlights; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Influenced & Special Jewellery" [activeRules]="activeRules.influencedJewelleryFiltersPoe1"></span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showJewelleryHighlights) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showJewelleryHighlights">
      <div class="filter filter-property full-span">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showInfluencedJewellery" (click)="toggleHighlightInfluencedJewellery()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'Influenced' : 'Influenced Jewellery'" [additionalContent]="influencedJewelleryStylePreview" [class.disabled]="!filter.showInfluencedJewellery" ruleId="jewellery-influenced">
            <ng-template #influencedJewelleryStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryInfluenced"
                [alignLeft]="true"
                [active]="filter.showInfluencedJewellery"
                exampleName="Amulet"
                [influence]="'Shaper'"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.OtherJewelleryFractured"
            filterPropertyName="showFracturedJewellery"
            labelText="Fractured"
            exampleName="Amulet"
            [fractured]="true"
            [rarity]="Rarity.Rare"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span">
        @if (!filter.ruthless) {
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showVeiledJewellery" (click)="toggleHighlightVeiledJewellery()"></button>
          </span>
        }
        <span class="filter-body">
          @if (!filter.ruthless) {
            <span filter-title [text]="isMobile() ? 'Veiled' : 'Veiled Jewellery'" [additionalContent]="veiledJewelleryStylePreview" [class.disabled]="!filter.showVeiledJewellery" ruleId="jewellery-veiled">
              <ng-template #veiledJewelleryStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherJewelleryVeiled"
                  [alignLeft]="true"
                  [active]="filter.showVeiledJewellery"
                  exampleName="Amulet"
                  [veiled]="true"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <app-autocomplete
              [allLabel]="'All Veiled'"
              [options]="syndicateMembers"
              [disabled]="!filter.showVeiledJewellery"
              [showOptions]="true"
              [selectedValues]="filter.showVeiledJewelleryOfSyndicateMembers || ['All Veiled']"
              (selectedValuesChange)="filter.showVeiledJewelleryOfSyndicateMembers = $event; updateFilter()">
            </app-autocomplete>
            <span class="sep"></span>
          }
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.OtherJewelleryMemoryStrands"
            filterPropertyName="showMemoryStrandJewellery"
            labelText="Memory Strands"
            exampleName="Amulet"
            [memoryStrands]="true"
            [rarity]="Rarity.Rare"></app-filter-checkbox-group>
          <span class="sep"></span>
          <input type="number" placeholder="Min" maxlength="3" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showMemoryStrandJewellery"
            [(ngModel)]="filter.showMemoryStrandJewelleryMinStrands" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showAnointedAmulets" (click)="toggleHighlightAnointedAmulets()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Double-Anointed Amulets" [additionalContent]="anointedAmuletsStylePreview" ruleId="jewellery-anointed-amulets">
            <ng-template #anointedAmuletsStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryAnointedAmulets"
                [alignLeft]="true"
                [active]="filter.showAnointedAmulets"
                exampleName="Paua Amulet"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showCorruptedImplicitJewels">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showCorruptedImplicitJewels" (click)="toggleHighlightCorruptedImplicitJewels()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'Jewels' : 'Corrupted Jewels'" [additionalContent]="corruptedImplicitJewelsStylePreview" ruleId="jewels-corrupted-implicit">
            <ng-template #corruptedImplicitJewelsStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryCorruptedJewels"
                [alignLeft]="true"
                [active]="filter.showCorruptedImplicitJewels"
                [exampleName]="filter.showCorruptedImplicitJewelsTypes[0] === 'All' ? jewelTypes[0].name : filter.showCorruptedImplicitJewelsTypes[0]"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'All'"
            [options]="jewelTypes"
            [disabled]="!filter.showCorruptedImplicitJewels"
            [showOptions]="true"
            [selectedValues]="filter.showCorruptedImplicitJewelsTypes"
            (selectedValuesChange)="filter.showCorruptedImplicitJewelsTypes = $event; updateFilter();"></app-autocomplete>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            {{ isMobile() ? 'Imp.' : 'Implicits' }}
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="Min" maxlength="1" pattern="[0-2]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showCorruptedImplicitJewels"
            [(ngModel)]="filter.showCorruptedImplicitJewelsMinImplicits" (change)="updateFilter()">
          <span class="sep"></span>
          <div class="filter-title filter-label">
            {{ isMobile() ? 'Exp.' : 'Explicits' }}
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="Min" maxlength="1" pattern="[0-6]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showCorruptedImplicitJewels"
            [(ngModel)]="filter.showCorruptedImplicitJewelsMinExplicits" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showCorruptedImplicitJewellery">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showCorruptedImplicitJewellery" (click)="toggleHighlightCorruptedImplicitJewellery()"></button>
        </span>
        <span class="filter-body">
          <span filter-title [text]="isMobile() ? 'Jewellery' : 'Corrupted Jewellery'" [additionalContent]="corruptedImplicitJewelleryStylePreview" ruleId="jewellery-corrupted-implicit">
            <ng-template #corruptedImplicitJewelleryStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryCorruptedJewellery"
                [alignLeft]="true"
                [active]="filter.showCorruptedImplicitJewellery"
                exampleName="Paua Amulet"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'All'"
            [options]="jewelleryClasses"
            [disabled]="!filter.showCorruptedImplicitJewellery"
            [showOptions]="true"
            [selectedValues]="filter.showCorruptedImplicitJewelleryClasses"
            (selectedValuesChange)="filter.showCorruptedImplicitJewelleryClasses = $event; updateFilter();"></app-autocomplete>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            {{ isMobile() ? 'Rar.' : 'Min Rarity' }}
          </div>
          <span class="sep"></span>
          <app-select-rarity
            [greaterThanOrEqualTo]="true"
            [includeNormal]="false"
            [includeUnique]="false"
            [disabled]="!filter.showCorruptedImplicitJewellery"
            [(ngModel)]="filter.showCorruptedImplicitJewelleryMinRarity"
            (selectedValueChange)="updateFilter()"></app-select-rarity>
          <span class="sep"></span>
          <div class="filter-title filter-label">
            {{ isMobile() ? 'Imp.' : 'Implicits' }}
          </div>
          <span class="sep"></span>
          <input type="number" placeholder="Min" maxlength="1" pattern="[0-2]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showCorruptedImplicitJewellery"
            [(ngModel)]="filter.showCorruptedImplicitJewelleryMinImplicits" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentClusterJewelBases || filter.economy === Economy.Fixed">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [disabled]="filter.economy === Economy.Fixed" [class.disabled]="filter.economy === Economy.Fixed" [class.off]="!filter.showExcellentClusterJewelBases || filter.economy === Economy.Fixed" (click)="toggleHighlightExcellentClusterJewelBases()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Excellent Cluster Jewel Bases" [additionalContent]="excellentClusterJewelBasesStylePreview" ruleId="jewels-cluster-excellent">
            @if (filter.economy === Economy.Fixed) {
              Cluster Jewel filters are not available on Fixed Economy yet.
            } @else {
              Excellent Cluster Jewel Bases are those which according to <a href="https://poe.ninja" target="_blank">poe.ninja</a> are worth at least {{ getClusterJewelTierCutoffLabel('Excellent') }}. Good ones are worth at least {{ getClusterJewelTierCutoffLabel('Good') }}.
              <br />You can create extra rules on the <a href="/custom-rules">Custom Rules</a> tab.
              <span class="tooltip-section">
                <h3>Excellent Cluster Jewel Bases <small>iLevel ≥ {{ filter.showClusterJewelBasesMinItemLevel }}</small></h3>
                @for (jewel of excellentClusterJewelBases; track jewel.iLevel) {
                  @if (jewel.iLevel >= filter.showClusterJewelBasesMinItemLevel) {
                    <strong>Level {{ jewel.iLevel }}</strong>
                    @for (jewel of jewel.jewels; track jewel.passiveNodes) {
                      <br /><img src="{{ clusterJewelBaseTypeMap[jewel.baseType] }}" style="width: 16px; height: 16px;"> {{ jewel.passiveNum }}-node:
                        <span class="tooltip-info">{{ jewel.passiveNodes?.join(', ') }}</span>
                    }
                    @empty {
                      <br /><span class="tooltip-info">None</span>
                    }
                    <br />
                  }
                }
              </span>
              <span class="tooltip-section">
                <h3>Good Cluster Jewel Bases <small>iLevel ≥ {{ filter.showClusterJewelBasesMinItemLevel }}</small></h3>
                @for (jewel of goodClusterJewelBases; track jewel.iLevel) {
                  @if (jewel.iLevel >= filter.showClusterJewelBasesMinItemLevel) {
                    <strong>Level {{ jewel.iLevel }}</strong>
                    @for (jewel of jewel.jewels; track jewel.passiveNodes) {
                      <br /><img src="{{ clusterJewelBaseTypeMap[jewel.baseType] }}" style="width: 16px; height: 16px;"> {{ jewel.passiveNum }}-node:
                        <span class="tooltip-info">{{ jewel.passiveNodes?.join(', ') }}</span>
                    }
                    @empty {
                      <br /><span class="tooltip-info">None</span>
                    }
                    <br />
                  }
                }
              </span>
            }

            <ng-template #excellentClusterJewelBasesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryExcellentClusterJewelBases"
                [active]="filter.showExcellentClusterJewelBases"
                exampleName="Large Cluster Jewel"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.OtherJewelleryGoodClusterJewelBases"
            filterPropertyName="showGoodClusterJewelBases"
            labelText="Good"
            exampleName="Large Cluster Jewel"
            [rarity]="Rarity.Rare"
            [disabledWhen]="!filter.showExcellentClusterJewelBases"></app-filter-checkbox-group>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Min Level
            </div>
          }
          <span class="sep"></span>
          <app-select [class.include-comparator]="false" [(ngModel)]="filter.showClusterJewelBasesMinItemLevel" (selectedValueChange)="updateFilter()"
            style="width: 70px;">
            @for (level of clusterJewelMinItemLevelOptions; track level) {
              <app-option [value]="level" [text]="'≥ ' + level"></app-option>
            }
          </app-select>
        </span>
      </div>

      <div class="filter filter-property filter-padded-left" style="width: 100%;">
        <span class="filter-body">
          <span filter-title text="Cluster Jewel Tiering Mode">
            This determines how Cluster Jewels are divided into tiers, by changing the cutoff values for each of the tiers. Define your own Tiering Mode with custom threshold values.
          </span>
          <span class="sep"></span>
          <app-select [class.include-comparator]="false" [(ngModel)]="filter.clusterJewelTieringMode" (selectedValueChange)="clusterJewelTieringModeChanged($event)">
            <app-option [value]="'Early'" [text]="'Early-game'"></app-option>
            <app-option [value]="'Normal'" [text]="'Normal'"></app-option>
            <app-option [value]="'Strict'" [text]="'Strict'"></app-option>
            <app-option [value]="'VeryStrict'" [text]="'Very Strict'"></app-option>
            <app-option [value]="'Custom'" [text]="'Custom'"></app-option>
          </app-select>
          @if (filter.clusterJewelTieringMode === 'Custom') {
            <span class="sep"></span>
            <button class="btn toggle-button show-filters-button" (click)="openCustomTieringDialog()">
              <span class="icon icon-equalizer"></span>
            </button>
          }
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>

@if (showCustomTieringDialog) {
  <app-custom-cluster-jewel-tiering-mode-dialog
    [filter]="filter"
    (close)="closeCustomTieringDialog()">
  </app-custom-cluster-jewel-tiering-mode-dialog>
}
